import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faTimes, 
  faCheckCircle, 
  faTimesCircle, 
  faExclamationTriangle, 
  faInfoCircle 
} from '@fortawesome/free-solid-svg-icons';
import styles from '../ManagerDashboard/Profile.module.css';

const AlertModal = ({ isOpen, onClose, alertConfig }) => {
  if (!isOpen) return null;
  
  const getAlertIcon = () => {
    switch (alertConfig.type) {
      case 'success':
        return faCheckCircle;
      case 'error':
        return faTimesCircle;
      case 'warning':
        return faExclamationTriangle;
      case 'info':
      default:
        return faInfoCircle;
    }
  };

  return (
    <div className={styles['modal-overlay']}>
      <div className={styles['modal-content']}>
        <button className={styles['modal-close']} onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <div className={styles['alert-header']}>
          <FontAwesomeIcon 
            icon={getAlertIcon()} 
            className={`${styles['alert-icon']} ${styles[alertConfig.type]}`}
          />
          <h3>{alertConfig.title}</h3>
        </div>
        <p className={styles['alert-message']}>{alertConfig.message}</p>
        <div className={styles['form-actions']}>
          {alertConfig.showCancel && (
            <button 
              className={styles['secondary-button']} 
              onClick={onClose}
            >
              Cancel
            </button>
          )}
          <button 
            className={styles['primary-button']} 
            onClick={() => {
              if (alertConfig.onConfirm) alertConfig.onConfirm();
              onClose();
            }}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertModal;